module.exports = require('../dist/react/impression');
